export enum RankGroupsQueryKeys {
  Primary = '/rank-groups',
  WithRanks = '/rank-groups/with-ranks',
  ById = '/rank-groups/:id',
}
